import {MenuOption} from '../../../menu-engine/MenuOption'
import {setBattleValue} from '../../../redux-actions/battle-actions.js'
import BattleActions from '../../battle-data/battle-actions.js'


export function getSubmissionHomeMenuData(playerModel) {

  const attackOption = {
    label: "Attack",
    viewBag: {
      actionCategory: "offense"
    },
    nextView: "targetsView",
    handleOptionEnter() {
      //Populate the node in state with our selected action!
      setBattleValue({
        arenaSubmissionMenuAction: {
          ...BattleActions["attack_generic-attack"],
          id: "attack_generic-attack",
          actionMeta: {actionId: "attack_generic-attack"} //include the actionMeta from our player state (the attacks I know, and Items with instanceIds)
        }
      })
    }
  };

  const specialsOption = {
    label: "Script...",
    viewBag: {
      actionCategory: "directory"
    },
    nextView: "specialsView",
  };

  const isItemsUnavailable = playerModel.getTeamItems().length === 0;
  const itemsOption = {
    label: "Item...",
    viewBag: {
      actionCategory: "directory",
    },
    nextView: "itemsView",
    isUnavailable() {
      return isItemsUnavailable
    }
  };




  return {
    "attackOption": new MenuOption(attackOption, "attackOption"),
    "specialsOption": new MenuOption(specialsOption, "specialsOption"),
    "itemsOption": new MenuOption(itemsOption, "itemsOption"),
    "superOption": new MenuOption(getSuperAction(playerModel), "superOption")
  }
}

//Provide the correct action to use.
function getSuperAction(playerModel) {

  const availableSupers = playerModel.getAvailableSupers(); //only ones that can be used right now
  const isSuperUnavailable = availableSupers.length === 0;
  
  const superActionId = getSuperId(playerModel);

  //const isRevertAvailable = Boolean(playerModel.getAvailableSupers().find(a => a.actionId === "special_revert"));

  //Case:
  //I only have 1 Super, so make this selection go directly to the targeting selection (like regular attack does)
  if (
    superActionId !== "SHOW-ALL"
  ) {

    const actionModel = BattleActions[superActionId];
    return {
      label: actionModel.name,
      viewBag: {
        actionCategory: actionModel.category,
        metaData: String(playerModel.dangerMeter) + "% Charged",
      },
      nextView: "targetsView",
      handleOptionEnter() {
        //Populate the node in state with our selected action!
        setBattleValue({
          arenaSubmissionMenuAction: {
            ...actionModel,
            id: superActionId,
            actionMeta: {actionId: superActionId} //include the actionMeta from our player state (the attacks I know, and Items with instanceIds)
          }
        })
      },
      isUnavailable() {
        return isSuperUnavailable
      }
    };
  }


  //Default case:
  //Return a list view of my supers ("SHOW-ALL")
  return {
    label: "Super Charge...",//playerSuperAction.name,
    viewBag: {
      actionCategory: "directory", //because it goes to a list view //TODO: is this the right call? It feels underwhelming. Not sure, but whatevs.

      //Danger Meter in Meta spot:
      metaData: String(playerModel.dangerMeter) + "% Charged",

      //We may want to apply a "COMMIT" badge here, like you have a Commit saved (ready for Revert)
      // hasRevertAvailable: isRevertAvailable //TODO: This is not being used at the moment. Do we need it?
    },
    isUnavailable() {

      //Do we have Supers that are available for use?
      // (isDangerMeterCheck already done in that method)
      return isSuperUnavailable
    },
    nextView: "supersView",
  };
}

export function getSuperId(playerModel) {

  const allPlayerSupers = playerModel.getAllSupers(); //all, regardless of ready or not
  const availableSupers = playerModel.getAvailableSupers(); //only ones that can be used right now

  //None are available
  if (availableSupers.length === 0 && allPlayerSupers.length > 0) {
    return allPlayerSupers[0].actionId;
  }

  //I only have 1 available, so show that one.
  if (availableSupers.length === 1) {
    return availableSupers[0].actionId;
  }

  if (availableSupers.length > 1) {
    return "SHOW-ALL" //special string flag for using a ListView
  }
}


// WEBPACK FOOTER //
// ./src/battle/ArenaView/SubmissionMenu/getSubmissionMenuDataHome.js